// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"70e7d564","498":"75ef9383","513":"87149d66","550":"376885aa","703":"77cb6d50","802":"2c651bc1","921":"907b4ad8"}[chunkId] + ".chunk.js";
};